<div class="bl-margin-bottom--40">
  <ea-accordion-group #disclosuresGroup [(accordionGroupMeta)]="accordionGroupMeta">
    <div
      *ngFor="let disclosure of disclosures; let i = index"
      class="bl-block-module bl-display--flex bl-font-color--base bl-padding--16 bl-padding-sm--24 bl-margin-bottom--16"
      id="disclosure-card-{{ i }}"
    >
      <ea-accordion
        #disclosureRef
        [defaultExpanded]="disclosure.isOpen == true"
        controllerPosition="above"
        [controllerInnerHtml]="disclosureTitleHtml(disclosure)"
        controllerClass="bl-display--flex bl-width--100 bl-font-color--base"
        class="bl-width--100"
        uniqueId="disclosure-{{ i }}"
      >
        <div class="bl-overflow-x--auto">
          <div
            class="bl-margin-y--16"
            *ngIf="!disclosure.isPDFFile || disclosure.content"
            [innerHTML]="this.utilitiesService.normalizeSpaces(disclosure.content | safe : 'html')"
          ></div>
        </div>

        <!-- Disclousre open poupup -->
        <div *ngIf="disclosure.isPDFFile || disclosure.isHtmlFile" class="bl-margin-top--8">
          <div class="bl-margin-bottom--16">
            <button
              id="{{disclosure_panel_id}}-{{i}}"
              [attr.data-automation-id]="disclosure_panel_id"
              class="disclosureLink bl-text-decoration--underline"
              (click)="chkSelection(disclosure, disclosureRef, disclosuresGroup); openSlideInPanel(disclosure, i)"
            >
              {{ 'disclosureReview/disclosureText' | dictionary }}
              {{ disclosure.title }}
            </button>
          </div>
        </div>

        <div *ngIf="disclosure.isLinkType" class="bl-margin-bottom--16">
          <a
            [href]="disclosure.url"
            class="disclosureLink"
            target="_blank"
            (click)="chkSelection(disclosure, disclosureRef, disclosuresGroup)"
            >{{ disclosure.urlDisplayText }}</a
          >
        </div>

        <ng-container *ngIf="isArray(disclosure.applicants); else disclosureAccept">
          <div *ngFor="let applicant of disclosure.applicants; let index = index">
            <div
              class="bl-display--flex bl-margin-bottom--16 bl-width--100 bl-flex-flow--wrap"
              [ngClass]="disclosure.applicants.length - 1 != index ? 'bl-padding-right--32' : ''"
            >
              <ng-container *ngIf="isOlaFlow || isOAOFlow">
                <div
                  class="bl-font-color--error bl-font-size--14 bl-margin-bottom--16"
                  aria-label="error"
                  aria-live="assertive"
                  *ngIf="!applicant.accepted && getAllowToAccept(disclosure) == true && (pageSubmitted$ | async)"
                >
                  {{ getApplicantLabel(applicant.applicant) }} {{ 'disclosureReview/initialMsg' | dictionary }} 
                  {{ disclosure.title}}{{ 'disclosureReview/errorMessage' | dictionary }}
                </div>
                <div
                  class="bl-font-color--error bl-font-size--14 bl-margin-bottom--16"
                  aria-label="error"
                  aria-live="assertive"
                  *ngIf="hasLink(disclosure) && getAllowToAccept(disclosure) !== true && (pageSubmitted$ | async)"
                >
                  {{ 'disclosureReview/errorDisclosureMsg' | dictionary }}
                </div>
              </ng-container>

              <div class="bl-check-wrap bl-required">
                <input type="checkbox" id="disclosure_acc_{{ i }}_{{ index }}" #name="ngModel" [(ngModel)]="applicant.accepted"
                (change)="updateAcceptance(disclosure.applicants, index, disclosureRef, disclosuresGroup); keepCheckboxFocus(i + '_' + index)" 
                required [disabled]="(hasLink(disclosure) && getAllowToAccept(disclosure) !== true) || applicant.disabled" />
                <label for="disclosure_acc_{{ i }}_{{ index }}" class="bl-label bl-font-weight--900"
                  [innerHTML]="applicant.label ? getApplicantLabel(applicant.label) : ('disclosureReview/acceptLabel' | dictionary)">
                </label>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-template #disclosureAccept>
          <div class="bl-display--flex bl-margin-bottom--16 bl-width--100">
            <div class="bl-check-wrap">
              <input type="checkbox" id="disclosure_{{ i }}" [checked]="disclosure.accepted"
              (click)="disclosure.accepted = !disclosure.accepted"
              (change)="updateAcceptance(disclosures, i, disclosureRef, disclosuresGroup); keepCheckboxFocus(i)"
              [disabled]="hasLink(disclosure) && getAllowToAccept(disclosure) !== true" />
              <label for="disclosure_{{ i }}" class="bl-label bl-font-weight--900">
                {{ 'disclosureReview/acceptLabel' | dictionary }}
              </label>
            </div>
          </div>
        </ng-template>
      </ea-accordion>
    </div>
  </ea-accordion-group>
</div>

<ea-slide-in-panel
  [(isSlidePanelVisible)]="isOpen"
  [slidePanelTitle]="docTitle"
  [fixedLayout]="true"
  openPanelElementId="{{disclosure_panel_id}}-{{panelIndex}}"
>
  <div *ngIf="isOpen" class="bl-border bl-border-radius bl-bg-color--white bl-padding-x--16 bl-padding-y--24 bl-padding-md--32">
    <ng-container *ngIf="isDataloaded">
      <div class="bl-display--flex bl-justify-content--flex-end bl-margin-bottom--16 bl-height--100">
        <h4 class="bl-margin-bottom--0 bl-font-weight--900 bl-font-color--black bl-font-size--18 bl-margin-right--auto">
          {{ 'disclosureReview/review' | dictionary }}
        </h4>
        <button
          *ngIf="isDataloaded && pdfURL"
          (click)="printPDF()"
          id="printPDF-disclosure"
          class="bl-padding-right--24 bl-font-color--steel"
        >
          <i class="cu-print bl-padding-right--8 bl-font-color--primary" alt="" aria-hidden="true"></i>
          <span>{{ 'disclosureReview/print' | dictionary }}</span>
        </button>

        <button *ngIf="isDataloaded && pdfURL" (click)="downloadPDF()" id="download-disclosure" class="bl-font-color--steel">
          <i  class="cu-inbox-download bl-padding-right--8 bl-font-color--primary" alt="" aria-hidden="true"></i>
          <span>{{ 'disclosureReview/download' | dictionary }}</span>
        </button>
      </div>
      <div class="bl-padding--16 bl-position--relative" *ngIf="isDataloaded && pdfURL">
        <ecp-pdf-embed [pdfSrc]="pdfURL"></ecp-pdf-embed>
      </div>
      <div [innerHTML]="content" *ngIf="content"></div>
    </ng-container>
    <ng-container *ngIf="isOpen && !isDataloaded">
      <div class="bl-padding--16 bl-position--relative">
        <p class="bl-margin-y--24 bl-font-color--steel" [innerHTML]="'disclosureReview/loadingText' | dictionary"></p>
        <ecp-content-spinner [spinnerSmall]="true"></ecp-content-spinner>
      </div>
    </ng-container>
  </div>
</ea-slide-in-panel>
